import {makeApiCallPost} from "../../Api/makeApiCall";
import {fromUniverseName, toUniverseName} from "./Components/storeUniverseTableHelpers";

export const CANONICAL_STORE_OVERRIDES_PATH = 'canonicalStoreOverrides';
export const CANONICAL_STORE_OVERRIDES_UPLOAD_PATH = `${CANONICAL_STORE_OVERRIDES_PATH}/upload`;
export const CANONICAL_STORE_OVERRIDES_BULK_UPLOAD_HISTORY_PATH = `${CANONICAL_STORE_OVERRIDES_PATH}/bulkUploadHistory`;
export const OVERRIDE_OPEN_DATE = 'openDate';
export const OVERRIDE_CLOSED_DATE = 'closedDate';
export const OVERRIDE_CLASSIFICATION = 'classification';
export const OVERRIDABLE_FIELDS = [OVERRIDE_OPEN_DATE, OVERRIDE_CLOSED_DATE, OVERRIDE_CLASSIFICATION];
export const OVERRIDE_UNIVERSE_ADD = 'overrideUniverseAdd';
export const OVERRIDE_UNIVERSE_REMOVE = 'overrideUniverseRemove';
export const UNIVERSE_OVERRIDE_FIELDS = [OVERRIDE_UNIVERSE_ADD, OVERRIDE_UNIVERSE_REMOVE];

export const canonicalStoreOverridesUrl = (version) =>
    `${process.env.REACT_APP_EDP_API_BASE_URL}/${CANONICAL_STORE_OVERRIDES_PATH}/?version=${encodeURIComponent(version)}`;

export const buildCanonicalStoreOverridesMap = (records) =>
    records.reduce((acc, record) => ({...acc, [record.canonicalStoreTag]: record}), {});

export const overrideValues = (override) => ({
    ...OVERRIDABLE_FIELDS.reduce((acc, field) => ({...acc, [field]: override?.[field] ?? ''}), {}),
    ...UNIVERSE_OVERRIDE_FIELDS.reduce(
        (acc, field) => ({...acc, [field]: (override?.[field] ?? []).map(fromUniverseName)}),
        {},
    ),
});

export const canonicalStoreOverridesUploadUrl = () =>
    `${process.env.REACT_APP_EDP_API_BASE_URL}/${CANONICAL_STORE_OVERRIDES_UPLOAD_PATH}`;

export const canonicalStoreOverridesBulkUploadHistoryUrl = () =>
    `${process.env.REACT_APP_EDP_API_BASE_URL}/${CANONICAL_STORE_OVERRIDES_BULK_UPLOAD_HISTORY_PATH}/`;

const apiErrorMessage = (apiError) => {
    const detail = apiError.response?.data?.detail;
    return typeof detail === 'string' ? detail : apiError.message;
};

const throwOnApiError = (response) => {
    if (response?.apiError) {
        throw new Error(apiErrorMessage(response.apiError));
    }
    return response;
};

export const saveCanonicalStoreOverride = (version, canonicalStoreId, values) => {
    const overrides = {
        ...OVERRIDABLE_FIELDS
            .filter(field => values[field])
            .reduce((acc, field) => ({...acc, [field]: values[field]}), {}),
        ...UNIVERSE_OVERRIDE_FIELDS
            .filter(field => values[field]?.length)
            .reduce((acc, field) => ({...acc, [field]: values[field].map(toUniverseName)}), {}),
    };
    const singleRowAction = Object.keys(overrides).length ? 'update' : 'delete';
    return makeApiCallPost(
        `${canonicalStoreOverridesUrl(version)}&single_row_action=${singleRowAction}`,
        {canonicalStoreId, ...overrides},
    ).then(throwOnApiError);
};

const postCanonicalStoreOverridesUpload = (version, filename, data, dryRun) =>
    makeApiCallPost(canonicalStoreOverridesUploadUrl(), {version, filename, data, encoding: 'utf-8', dryRun})
        .then(throwOnApiError);

export const previewCanonicalStoreOverridesUpload = (version, filename, data) =>
    postCanonicalStoreOverridesUpload(version, filename, data, true);

export const uploadCanonicalStoreOverrides = (version, filename, data) =>
    postCanonicalStoreOverridesUpload(version, filename, data, false);

export const canonicalStoreOverridesSuccessMessage = (filename, response) =>
    `${filename} uploaded successfully: ${response?.applied ?? 0} store override(s) applied, ` +
    `${response?.unchanged ?? 0} unchanged, ${response?.skipped ?? 0} row(s) skipped`;
